import { effect } from "@preact/signals-react";
import { useSignals } from "@preact/signals-react/runtime";
import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect } from "react";

import { primaryLocale } from "../Components/Settings/settingsState";
import { APP_REFRESH_INTERVAL } from "../constants";
import { getEnv } from "../utils/env.utils";

type Props = {
	children: React.ReactNode;
};

export const QueryClientProvider = ({ children }: Props) => {
	useSignals();
	useEffect(() => {
		const interval = setInterval(() => {
			window.location.reload();
		}, APP_REFRESH_INTERVAL);

		return () => clearInterval(interval);
	}, []);

	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				retry: false,
			},
		},
	});
	/**
	 * Reset Query client on local change to update x-locale header
	 */
	effect(() => {
		if (primaryLocale.value) {
			queryClient.clear();
		}
	});
	return (
		<TanstackQueryClientProvider client={queryClient}>
			{getEnv() === "DEV" && (
				<ReactQueryDevtools client={queryClient} initialIsOpen={false} buttonPosition="bottom-right" />
			)}
			{children}
		</TanstackQueryClientProvider>
	);
};
